import script from "./ManageDocumentSubjectsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageDocumentSubjectsView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageDocumentSubjectsView.vue?vue&type=style&index=0&id=cdc34fec&lang=scss"

const __exports__ = script;

export default __exports__